export const LOCAL_BASE_API_URL = "https://localhost:5001/api";
export const LOCAL_BASE_URL = "http://localhost:3000";
export const DEV_BASE_URL = "https://streetlightsdev.consumersengergy.com";
export const CONFIG_BASE_URL = "../../";
export const LOCAL_SWAGGER = "https://localhost:5001/swagger/1/swagger.json";

export const LOOKUPS_ENDPOINT = "/lookups";
export const OUTAGES_ENDPOINT = "/outages";
export const SEARCH_OUTAGES_ENDPOINT = "/outages/search";
export const ADMIN_OUTAGES_ENDPOINT = "/outages/admin";
export const ADMIN_LOGIN_ENDPOINT = "/?admin_mode=true";
export const VERSION_ENDPOINT = "/version";
export const CONFIG_ENDPOINT = "environment.config.json";

/**
 * NOTE: THIS IS ONLY USED FOR TESTING. appConfig VALUES ARE
 * RETRIEVED FROM slices/globalSlice ==> fetchAppConfig and intialized in
 * BaseMap.component.
 */
export const DEFAULT_APP_CONFIG = {
  env: "dev",
  apiUrl: "https://streetlightsdev.consumersenergy.com/api",
  apimSubscriptionKey: "218694dea0fe4d198fb5cf8220399fc5",
  esriStreetlightLayerId: "StreetlightsOutage_PROD",
  esriRestrictedLayerId: "Electric_WHQs",
  esriGrandRapidsLayerId: "Grand Rapids Streetlights",
  esriSaginawLayerId: "Saginaw_Streetlights_06082022_Non_Prod",
  esriFeatureLayerUrl:
    "https://services.arcgis.com/T2graiaSQnlmwwmp/arcgis/rest/services/StreetlightsOutage_NON_PROD_View/FeatureServer/0",
  esriGrandRapidsLayerUrl:
    "https://services.arcgis.com/T2graiaSQnlmwwmp/arcgis/rest/services/Grand_Rapids_Streetlights_View/FeatureServer/0",
  esriRestrictedFeatureLayerUrl:
    "https://services.arcgis.com/T2graiaSQnlmwwmp/arcgis/rest/services/UNK_Electric_WHQs/FeatureServer/0",
  esriSaginawLayerUrl:
    "https://services.arcgis.com/T2graiaSQnlmwwmp/ArcGIS/rest/services/Saginaw_Streetlights_06082022_Non_Prod/FeatureServer/0",
  oktaClientId: "0oa2gwqrxmYlTX7yj5d7",
  oktaIssuer: "https://dev-35438015.okta.com/oauth2/default",
  oktaRedirectUri: "http://localhost:3000/?logged_in=true",
  oktaScopes: "openid, profile, email",
  oktaPKCE: "true",
};
